import Section from "@/components/Section";
import Breadcrumb from "@/components/UI-Kit/Breadcrumb";
import { getBreadcrumbRoute } from "@/utils/getBreadcrumbRoute";
import { Box, Container, Typography, useTheme } from "@mui/material";
import { useLocation } from "react-router";
import icon_url from "@/assets/icons/installation-guides/installation.svg";
import thumbnail_url from "@/assets/images/installation-guide/installation_thumbnail.png";
import ProductsSection from "./components/ProductsSection";
import AnimatedImage from "@/components/UI-Kit/AnimatedImage";

const InstallationGuide = () => {
  const location = useLocation();
  const theme = useTheme();
  return (
    <>
      <Container sx={{ pt: { xs: 3, lg: 0 }, pb: { xs: 3, md: 0 } }}>
        <Breadcrumb options={getBreadcrumbRoute(location)} />
      </Container>
      <Section pt={{ xs: 0, md: 6 }} pb={{ xs: 0, md: 6 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            justifyContent: { md: "space-between" },
          }}
        >
          <Box
            sx={{
              marginBottom: { xs: "24px", md: "0px" },
              alignSelf: { xs: "start", md: "center" },
            }}
          >
            <Typography
              variant="h1"
              color={theme.palette.grey[800]}
              sx={{
                maxWidth: "795px",
                marginBottom: { xs: "16px", md: "26px" },
              }}
            >
              Seamless Installation for Maximum Performance
            </Typography>
            <Typography
              variant="subtitle1"
              component="p"
              color={theme.palette.grey[600]}
              sx={{
                maxWidth: "442px",
              }}
            >
              Unlock the full potential of your Trackmate devices with our detailed installation guides. Learn how to set up your tracking systems efficiently and effectively, ensuring you get the best performance every time. 
            </Typography>
          </Box>
          <AnimatedImage
            sx={{
              width: "100%",
              maxWidth: { xs: "375px", md: "601px" },
              img: {
                width: "100%",
                height: "auto",
              },
            }}
            thumbnailUrl={thumbnail_url}
            mainUrl={icon_url}
            alt="troubleshooting"
          />
        </Box>
      </Section>
      <ProductsSection />
    </>
  );
};

export default InstallationGuide;
